import _ from 'lodash';
import { Table } from 'reactstrap';
import React from 'react';
import domainModel from 'domain-model';
import { weekdays, weekdayMap } from './common';

const { DeliveryRule } = domainModel.deliveryRules;

type DeliveryRulesEditorType =
  typeof domainModel.deliveryRules.DeliveryRulesEditor;

interface SimplifiedRulesInputProps {
  region: string;
  onChange: () => void;
  deliveryRulesEditor?: DeliveryRulesEditorType;
}
const SimplifiedRulesInput: React.FC<SimplifiedRulesInputProps> = props => {
  const { onChange, deliveryRulesEditor, region } = props;

  const onEnableChange = (key: string, newEnabled: boolean) => {
    if (newEnabled) {
      const newRoute = DeliveryRule.createSelectedRoute(key);
      deliveryRulesEditor.addDeliveryRule(newRoute);
    } else {
      deliveryRulesEditor.removeDeliveryRule(region, key);
    }
    onChange();
  };

  const hasNullRules = deliveryRulesEditor.getRawDeliveryRules() === null;

  return (
    <div>
      <Table>
        <tbody>
          <tr>
            {weekdays.map(weekday => {
              const deliveryRule = deliveryRulesEditor.getRuleWithRegionAndKey(
                region,
                weekday.key,
              );
              return (
                <td style={{ verticalAlign: 'middle' }}>
                  <label style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      type="checkbox"
                      checked={!_.isNil(deliveryRule) || hasNullRules}
                      onChange={() =>
                        onEnableChange(weekday.key, _.isNil(deliveryRule))
                      }
                    />
                    &nbsp;
                    {weekdayMap[weekday.key]?.value}
                  </label>
                </td>
              );
            })}
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default SimplifiedRulesInput;
